import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { ICommodity } from '../commodity/commodity';
import { IOptionType } from '@zz2/zz2-ui';
import OptionType from '../../optionType';
import { IVariety } from './variety';
import { IVarietyFormValues } from './varietyFormValues';
import { IVarietyUpsert } from './varietyUpsert';

export default class VarietyModelHelper {
    public static createFormValues = (
        variety : IVariety | null,
        commodities : Array<ICommodity>,
        defaultCommodity : ICommodity | null
    ) : IVarietyFormValues => {
        if (!variety) return {
            id: 0,
            guid: uuidV4(),
            code: '',
            name: '',
            commodity: defaultCommodity
                ? OptionType.fromDataModel(defaultCommodity)
                : null,
            isActive: true,
        };

        const commodity = commodities.find(x => x.id === variety.commodityId);

        return {
            id: variety.id,
            guid: variety.guid,
            code: variety.code,
            name: variety.name ?? '',
            commodity:  commodity
                ? OptionType.fromDataModel(commodity)
                : null,
            isActive: variety.isActive,
        };
    };

    public static createUpsert = (formValues : IVarietyFormValues) : IVarietyUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            code: formValues.code,
            name: formValues.name,
            commodityId: Number(formValues.commodity?.value ?? 0),
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IVarietyFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        code: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        commodity: Yup.mixed<IOptionType>().defined().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
